import styled from "@emotion/styled";
import { PureComponent, ReactElement } from "react";

import { DesignToken, RadiusToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

import { Chart, IChartProps } from "./Chart";

const StyledContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  box-sizing: border-box;
  margin-bottom: ${withVar(SpacingToken.Spacing5)};

  &:last-child {
    margin-bottom: 0;
  }
`;

const Description = styled(Text)`
  margin-block-end: ${withVar(SpacingToken.Spacing6)};
  text-align: end;
  color: ${withVar(DesignToken.ContentBasicSecondary)};
`;

const ChartContainer = styled.div`
  border-radius: ${withVar(RadiusToken.Radius3)};
  border: solid 1px ${withVar(DesignToken.BorderBasicSecondary)};
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  box-sizing: border-box;
  padding: ${withVar(SpacingToken.Spacing5)};
`;

type IProps = IChartProps;

export class ChartPanel extends PureComponent<IProps> {
  render(): ReactElement {
    const { description, ...chartProps } = this.props;

    return (
      <StyledContainer>
        {description && <Description>{description}</Description>}
        <ChartContainer>
          <Chart {...chartProps} />
        </ChartContainer>
      </StyledContainer>
    );
  }
}
